import { render, staticRenderFns } from "./sensor-management.component.vue?vue&type=template&id=37580895"
import script from "./sensor-management.component.ts?vue&type=script&lang=js&external"
export * from "./sensor-management.component.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports